import PropTypes from 'prop-types';

const StopSlidesIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill} fillRule="evenodd">
        <path d="m19.351 21.095 4.642 4.649 4.646-4.646c1.815-1.817 4.599.916 2.755 2.76l-4.641 4.644 4.641 4.646c1.815 1.812-.945 4.572-2.755 2.76l-4.646-4.646-4.642 4.644c-1.814 1.814-4.57-.946-2.76-2.758l4.647-4.646-4.647-4.644c-1.81-1.815.946-4.575 2.76-2.76v-.003z" />
        <path d="M42 4a6 6 0 0 1 6 6v27.998a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V10a6 6 0 0 1 6-6h36zm1.5 13.5h-39v18.998a3 3 0 0 0 2.693 2.986l.307.014h33a3 3 0 0 0 2.986-2.692l.014-.308V17.5zm-3-9h-33a3 3 0 0 0-2.986 2.693L4.5 11.5V13h39v-1.5c0-1.656-1.344-3-3-3z" />
      </g>
    </svg>
  </div>
);

StopSlidesIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

StopSlidesIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default StopSlidesIcon;
